import { render, staticRenderFns } from "./CampusAreas.vue?vue&type=template&id=c81aba10&scoped=true"
import script from "./CampusAreas.vue?vue&type=script&lang=js"
export * from "./CampusAreas.vue?vue&type=script&lang=js"
import style0 from "./CampusAreas.vue?vue&type=style&index=0&id=c81aba10&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c81aba10",
  null
  
)

export default component.exports